import _ from "lodash";
import { toast } from "react-toastify";

import API from "../../api";
import { formatResponse } from "../../formatResponses/reports";
import { usePackagesReport } from "../../../store/reports/usePackagesReport";

export default class PackagesReportModel {
  setPackagesReport = usePackagesReport.getState().actions.setPackagesReport;
  clearPackagesReport = usePackagesReport.getState().actions.clearPackagesReport;
  setSummaryData = usePackagesReport.getState().actions.setSummary;
  setLoading = usePackagesReport.getState().actions.setLoading;
  setWaiting = usePackagesReport.getState().actions.setWaiting;
  setFilterData = usePackagesReport.getState().actions.setFilter;
  setSortData = usePackagesReport.getState().actions.setSort;
  setPaginationPage = usePackagesReport.getState().actions.setPaginationPage;

  constructor() {
    this.name = "reports-store-packages";
    // sem campo de data na tela, o relatorio cobre todo o historico
    this.setFilterData({ dateFrom: null, dateTo: null });
  }

  currentFilter() { return usePackagesReport.getState().data.filter; }
  currentSort() { return usePackagesReport.getState().data.sort; }
  setFilter(filterProps) { this.setFilterData(filterProps); }
  setSort(sortProps) { this.setSortData(sortProps); }

  async setPage(page) {
    const pageExists = usePackagesReport.getState().data.packagesReport[page];
    this.setPaginationPage(page);
    if (!pageExists) await this.getPackagesReport();
  }

  async findPackagesReport() {
    await this.getPackagesReport();
  }

  async filterPackagesReport() {
    this.setLoading(true);
    this.setPaginationPage(0);
    this.clearPackagesReport();
    await this.getPackagesReport();
    this.setLoading(false);
  }

  async getPackagesReport() {
    try {
      this.setWaiting(true);

      const { data } = await API.get("reports/packages", { params: this.options() });
      const page = usePackagesReport.getState().data.pagination.page;

      this.setPackagesReport(
        formatResponse.packagesReport(data?.results),
        formatResponse.listPagination(data?.pagination, page)
      );
      if (data?.panel) this.setSummaryData(formatResponse.packagesPanel(data.panel));

      this.setWaiting(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.friendly_message ||
          error?.message ||
          "Não foi possível carregar o relatório de pacotes.",
        { theme: "colored" }
      );
      this.setWaiting(false);
      return null;
    }
  }

  async export() {
    try {
      await API.post("reports/export", {
        filters: this.filters(this.currentFilter()),
        type: { name: "package", format: "xlxs" },
      });
      toast.success("Exportação iniciada. O arquivo aparece em Minhas Exportações.", { theme: "colored" });
    } catch (error) {
      toast.error(
        error?.response?.data?.friendly_message || error?.message || "Não foi possível exportar o relatório.",
        { theme: "colored" }
      );
    }
  }

  filters(filter) {
    return _.omitBy(
      {
        dateFrom: filter.dateFrom || undefined,
        dateTo: filter.dateTo || undefined,
        status: filter.status !== "*" ? filter.status : undefined,
        cpf: filter.cpf ? filter.cpf.replace(/\D/g, "") : undefined,
        search: filter.search || undefined,
      },
      _.isUndefined
    );
  }

  options() {
    const sort = usePackagesReport.getState().data.sort;
    const pagination = usePackagesReport.getState().data.pagination;

    return {
      currentePage: (pagination.page || 0) + 1,
      perPage: pagination.perPage || 50,
      sortBy: sort.sortBy,
      sortOrder: sort.sortOrder,
      ...this.filters(this.currentFilter()),
    };
  }
}
